import React from 'react';
import PropTypes from 'prop-types';

export const FxPageContainer = ({ children, className }) => (
  <div className={className}>{children}</div>
);

FxPageContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  className: PropTypes.string,
};

FxPageContainer.defaultProps = {
  className: 'container stack-1 margin-2-tb',
};
